var isObject = require('../internals/is-object');

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw TypeError(String(argument) + ' is not an object');
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/an-object.js
// module id = 50
// module chunks = 1